module.exports = __webpack_public_path__ + "static/81-0121c588baa9e2da3e6d70a49aeaae88.png";